import create from './create-type';

const type = 'layout';

export const TOGGLE_DRAWER = create(type, 'TOGGLE_DRAWER');

export const ADD_NOTIFICATION = create(type, 'ADD_NOTIFICATION');
export const REMOVE_NOTIFICATION = create(type, 'REMOVE_NOTIFICATION');
